module.exports = __webpack_public_path__ + "img/banner-07.054ff059.jpg";